import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_317b3b4c";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_317b3b4c" };
/** script content **/
require("./modal.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex317b3b4c%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fmodal%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_317b3b4c"],
    ctorType: "component",
    outputPath: "components/index317b3b4c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-popup': getComponent(require("../popup/index.mpx?isComponent&outputPath=components%2Findex106ca599%2Findex")), 'cube-icon': getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex")), 'cube-confirm-button-group': getComponent(require("./confirm-button-group/index.mpx?isComponent&outputPath=components%2Findex68efc40c%2Findex")), 'mpx-rich-text': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
